import {Form} from "@/utils/Form";
import {FormattedFormRow} from "@dvrt/graphql-widgets";
import {Checkbox} from "@mui/material";
import {DeleteExtensionMutation, DeleteExtensionMutationVariables} from "./queries.generated";
import {defineMessages} from "react-intl";

type RowProps = {
    form: Form<DeleteExtensionMutation, DeleteExtensionMutationVariables>;
    label: keyof DeleteExtensionMutationVariables;
};

const TRANSLATIONS = defineMessages<keyof DeleteExtensionMutationVariables>({
    deleteVoicemailHistory: {
        id: "extension.delete.extra.deleteVoicemailHistory",
        defaultMessage: "Voicemail history",
    },
    deletePersonalAddressbook: {
        id: "extension.delete.extra.deletePersonalAddressbook",
        defaultMessage: "Personal addressbook",
    },
    deletePresenceData: {
        id: "extension.delete.extra.deletePresenceData",
        defaultMessage: "Presence data",
    },
    deleteChatHistory: {
        id: "extension.delete.extra.deleteChatHistory",
        defaultMessage: "Chat history",
    },
    userId: null,
    relatedData: null,
});

export const PersonalDataRow = ({form, label}: RowProps) => (
    <FormattedFormRow label={TRANSLATIONS[label]}>
        <Checkbox
            value={form.values[label]}
            checked={form.values[label] as boolean}
            onChange={(event) => form.updateValues({[label]: event.currentTarget.checked})}
        />
    </FormattedFormRow>
);

type Props = {
    form: Form<DeleteExtensionMutation, DeleteExtensionMutationVariables>;
};

export const PersonalDataList = ({form}: Props) => (
    <>
        <PersonalDataRow form={form} label="deleteVoicemailHistory" />
        <PersonalDataRow form={form} label="deletePersonalAddressbook" />
        <PersonalDataRow form={form} label="deletePresenceData" />
        <PersonalDataRow form={form} label="deleteChatHistory" />
    </>
);
